<template>
	<div class="content">
	  <base-header class="pb-6">
		<div class="row align-items-center py-4">
		  <div class="col-lg-6 col-7">
			<h6 class="h2 text-white d-inline-block mb-0">
			  {{ $t("report_by_sale_channel") }}
			</h6>
			<nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
			  <route-bread-crumb></route-bread-crumb>
			</nav>
		  </div>
		</div>
	  </base-header>
	  <div class="container-fluid mt--6">
		<div>
		  <card
			class="no-border-card"
			body-classes="px-0 pb-1"
			footer-classes="pb-2"
		  >
			<template slot="header">
			  <div class="row">
  
				<div class="form-group row">
				  <div class="col-md-3">
					<base-input>
					  <flat-picker
						slot-scope="{ focus, blur }"
						@on-open="focus"
						@on-close="blur"
						:config="{ allowInput: true }"
						class="form-control datepicker"
						v-model="startDate"
					  >
					  </flat-picker>
					</base-input>
				  </div>
  
				  <div class="col-md-3">
					<base-input>
					  <flat-picker
						slot-scope="{ focus, blur }"
						@on-open="focus"
						@on-close="blur"
						:config="{ allowInput: true }"
						class="form-control datepicker"
						v-model="endDate"
					  >
					  </flat-picker>
					</base-input>
				  </div>
  
  
				  <div class="col-md-5 row">
					<base-button size="md" type="primary" @click="handleSearch()">
					  Search
					</base-button>
					<base-button size="md" type="primary" @click="handleDownloadXLSX()">
					  Export
					</base-button>
				  </div>
				</div>
			  </div>
			</template>
			<div>
			  <el-table
				:data="queriedData"
				row-key="id"
				header-row-class-name="thead-light"
				@sort-change="sortChange"
				@selection-change="selectionChange"
			  >
				<el-table-column
				  v-for="column in tableColumns"
				  :key="column.label"
				  v-bind="column"
				>
				</el-table-column>
  

				<el-table-column :label="$t('payment_amount')">
					<div slot-scope="{ row }" class="d-flex">
						<span> {{ FormatCurrency(row.Amount) }} </span>
					</div>
				</el-table-column>

				<!-- <el-table-column
				  min-width="200px"
				  align="right"
				  :label="$t('actions')"
				>
				  <div slot-scope="{ $index, row }" class="d-flex">
					<base-button
					  @click.native="handleDetail($index, row)"
					  class="edit"
					  type="warning"
					  size="sm"
					  icon
					>
					  <i class="text-dtac-bt fa fa-edit"></i>
					  Detail
					</base-button>
				  </div>
				</el-table-column> -->
			  </el-table>
			</div>
			<div
			  slot="footer"
			  class=" col-12 d-flex justify-content-center justify-content-sm-between flex-wrap "
			  v-if="tableData.length != 0"
			>
			  <div class="">
				<p class="card-category">
				  {{ $t("data") }} {{ from + 1 }} {{ $t("to") }} {{ to }}
				  {{ $t("of") }}
				  {{ total }}
				  <span v-if="selectedRows.length">
					- &nbsp; &nbsp; {{ selectedRows.length }}
					{{ $t("row_select") }}
				  </span>
				</p>
			  </div>
			  <base-pagination
				class="pagination-no-border"
				v-model="pagination.currentPage"
				:per-page="pagination.perPage"
				:total="total"
			  >
			  </base-pagination>
			</div>
		  </card>
		</div>
	  </div>
	</div>
  </template>
  <script>
  import { Table, TableColumn, Select, Option } from "element-ui";
  import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
  import { BasePagination } from "@/components";
  import clientPaginationMixin from "../PaginatedTables/clientPaginationMixin";
  import swal from "sweetalert2";
  import { mapGetters, mapActions } from "vuex";
  import flatPicker from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  import moment from 'moment'
  import { read, utils, writeFile } from 'xlsx'

  export default {
	mixins: [clientPaginationMixin],
	components: {
	  flatPicker,
	  BasePagination,
	  RouteBreadCrumb,
	  [Select.name]: Select,
	  [Option.name]: Option,
	  [Table.name]: Table,
	  [TableColumn.name]: TableColumn,
	},
	computed: {
	  ...mapGetters({
		tableData: "Report/getReportSaleChannel",
	  }),
	  tableColumns: function () {
		return [
		  {
			prop: "Name",
			label: this.$t("sale_channel"),
			minWidth: 90,
			sortable: true,
		  },
		  {
			prop: "Cnt",
			label: this.$t("order_amount"),
			minWidth: 100,
			sortable: true,
		  },
		
		];
	  },
	},
	data() {
	  return {
		propsToSearch: ["Name"],
		selectedRows: [],
		SearchKeyword: "",
		startDate: "",
		endDate: "",
		
	  };
	},
	mounted() {
		this.startDate = moment().add(-30, 'days').format('YYYY-MM-DD');
		this.endDate = moment().format('YYYY-MM-DD');
		this.handleSearch()
	},
	methods: {
	  ...mapActions({
		listData: "Report/listReportSaleChannel",
	  }),
	  async handleSearch() {
		let params = {
		  time_from: this.startDate,
		  time_to: this.endDate,
		};
		await this.listData(params);
		this.sortChange({prop:"Cnt",order:""})

	  },
	  handleExport(){
		const csvString = [
        ["ช่องทางการขาย", "จำนวนรายการสั่งซื้อ", "จำนวนเงิน"],
        ...this.tableData.map((item) => [
          item.Name,
          item.Cnt,
          item.Amount,
        ]),
      ]
        .map((e) => e.join(","))
        .join("\n");

      let csvContent = "data:text/csv;charset=utf-8,\ufeff" + csvString;
      var encodedUri = encodeURI(csvContent);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", "report_sale_channel.csv");
      document.body.appendChild(link); // Required for FF

      link.click();
	  },

	  async handleDownloadXLSX(index,row){

			let dataExport = this.tableData.map((item)=>{
				return {
                    "ช่องทางการขาย" : item.Name,
                    "จำนวนรายการสั่งซื้อ" : item.Cnt,
                    "จำนวนเงิน" : item.Amount
                }
			})

			const dataWS = utils.json_to_sheet(dataExport)
			const wb = utils.book_new()
			utils.book_append_sheet(wb, dataWS)
			writeFile(wb,`sale_channel_${this.startDate}_${ this.endDate}.xlsx`)

		},
  
	  handleDetail(index, row) {
		// this.$router.push("/wms/historydetail/" + row.ID);
		window.open("/#/wms/historydetail/" + row.ID);
	  },
	  selectionChange(selectedRows) {
		this.selectedRows = selectedRows;
	  },
	},
  };
  </script>
  <style>
  .no-border-card .card-footer {
	border-top: 0;
  }
  </style>
  